<template>
  <!-- 注册账号 -->
  <div class="register-box">
    <!-- 步骤条 -->
    <div class="step">
      <img v-if="stepActive===1" src="./assets/images/ues_progress bar1.png" alt="">
      <img v-if="stepActive===2" src="./assets/images/ues_progress bar2.png" alt="">
      <img v-if="stepActive===3" src="./assets/images/ues_progress bar3.png" alt="">
      <img v-if="stepActive===4" src="./assets/images/ues_progress bar4.png" alt="">
    </div>
    <div class="verification-box">
      <!--注册-->
      <Register v-if="stepActive===1" :userTest="userTest" :stepActive="stepActive" @setStepActive="setStepActive" @sendUserInfo="sendUserInfo" />
      <!-- 验证 -->
      <Verification v-if="stepActive===2" :stepActive="stepActive" :info="info" :userTest="userTest" @changeVerifyMode="changeVerifyMode" @setStepActive="setStepActive" @sendVerifyCode="sendVerifyCode" />
      <!-- 设置密码 -->
      <SetPassword v-if="stepActive===3" :stepActive="stepActive" :userTest="userTest" :info="info" @setStepActive="setStepActive" />
      <!-- 注册成功 -->
      <RegisterSucces v-if="stepActive===4" :stepActive="stepActive" @setStepActive="setStepActive" />
    </div>
  </div>
</template>

<script>
// 注册组件
import Register from "@/components/register/register"
// 验证组件
import Verification from '@/components/verification/verification';
// 设置密码组件
import SetPassword from '@/components/register/setPassword';
// 设置密码成功组件
import RegisterSucces from '@/components/register/registerSucces';

export default {
  name: "registerAccount",
  components: {
    Register,
    Verification,
    SetPassword,
    RegisterSucces
  },
  data() {
    return {
      // 验证内容
      info: {
        loginPhone: null, //注册验证所用电话号码及邮箱共用一个变量loginPhone
        VerifyCode: ''// 验证码
      },
      //步骤条选中
      stepActive: 1,
      // 接收验证类别
      userTest: HAVE_PHONE ? "userPone" : "userEmail",
    }
  },
  created() { },
  mounted() { },
  methods: {
    // 重新设置setStepActive
    setStepActive(data) {
      this.stepActive = data
    },
    //验证---换一个验证方式
    changeVerifyMode(data) {
      this.userTest = data
    },
    // 注册---验证信息 手机|邮箱
    sendUserInfo(data) {
      if (data.loginPhone) {
        this.info.loginPhone = data.loginPhone
      } else if (data.loginEmail) {
        this.info.loginPhone = data.loginEmail
      }
    },
    // 注册---获取验证码
    sendVerifyCode(data) {
      this.info.VerifyCode = data
    }
  },
}
</script>

<style lang="less" scoped>
.register-box {
  padding-top: 40px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  .step {
    width: 100%;
    height: 66px;
    text-align: center;
  }
  .verification-box {
    margin: 67px auto 0;
    width: 460px;
    height: 518px;
  }
}
</style>